const formatDate = (date) => {
    const formattedDate = new Date(date);

    let hours = formattedDate.getHours();
    let minutes = formattedDate.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    const timePart = hours + ':' + minutes + ' ' + ampm;

    return `${formattedDate.getDate()}/${
        formattedDate.getMonth() + 1
    }/${formattedDate.getFullYear()}, ${timePart}`;
};

// The response allowance resets on a rolling 30-day boundary, not on the 1st of
// the month, so copy names the actual reset date rather than a calendar month.
export const formatResponseReset = (responsePeriodEnd) => {
    if (!responsePeriodEnd) return null;

    const reset = new Date(responsePeriodEnd);
    if (Number.isNaN(reset.getTime())) return null;

    return reset.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
    });
};

export default formatDate;
